<template>
  <!-- ファイル削除確認依頼 -->
  <ModalDialog
    pop-name="ファイル削除確認依頼"
    dialog-height="auto"
    margin-class="mtp-3 mbm-3"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div class="transFer_L mtp-3">
        <div>
          <transFer
            :data_left="data_left"
            :data_right="data_right"
            :title_l="title_l"
            :title_r="title_r"
          >
          </transFer>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="d-flex justify-content-center">
        <ButtonDelete button-name="削除依頼" @click="del"></ButtonDelete>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
import TransFer from '@/components/transFer.vue'
export default {
  name: 'FileDeletionConfirmationRequestDialog',
  components: { TransFer },
  props: {
    list: Array
  },
  data() {
    return {
      checklist: [],
      data_left: [{ name: '担当者A' }, { name: '担当者B' }],
      data_right: [{ name: '担当者C' }, { name: '担当者D' }],
      title_l: 'システム管理者一覧',
      title_r: '依頼先'
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    del() {
      this.$emit('close')
    },
    add() {
      let aa = []

      aa = this.list.filter(manager => manager.isTrue === true)
      this.checklist = aa
    },
    onClose(checked) {
      this.checklist.splice(checked, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.badge {
  font-size: 16px;
  .text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .b-form-tag-remove {
    border: 0;
  }
  .close {
    border: 0;
  }
}
</style>
